import { ChangeDetectorRef, Component, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BookingService } from 'app/modules/bookings/services/booking.service';
import * as momentImported from 'moment';
const moment = (momentImported as any).default || momentImported;
import { ConfirmationService, Message } from 'primeng/api';
import { MiGrid2Component } from '../../../shared/components/mi-grid-2/mi-grid-2.component';
import { CommonBindingDataService } from '../../../shared/services/common-binding-data.service';
import { AppSettings } from '../../app.settings';
import { CriticalScreenFiltersDataModel } from '../../save-filter-models/critcal-screen-filters-data-model';
import { CriticalScreenFilterModel } from '../../save-filter-models/critical-screen-filter-model';
import { PickupLocationOptionsService } from '../../services/pickup-location-options.service';
import { StorageService } from '../../services/storage.service';
import { UiService } from '../../services/ui.service';
import { UserCommonService } from '../../services/user-common.service';

@Component({
  selector: 'app-shared-critical-journey',
  templateUrl: './shared-critical-journey.component.html',
  styleUrls: ['./shared-critical-journey.component.scss']
})
export class SharedCriticalJourneyComponent implements OnInit, OnDestroy {

  @ViewChild(MiGrid2Component) gridRef2: MiGrid2Component;

  gridTheme = 'mi';
  showSerialNo = false;
  url = '';
  tempUrl = '/secure/tour/list/data?type=ACTIVE&subServiceType=CRITICAL';
  urlMethod: string = AppSettings.BOOKING_GRID_API_METHOD;
  bodyMapping: any = {
    type: 'string',
    subServiceType: 'array',
    pickupAddressId: 'array',
    dropAddressId: 'array',
    passengerTypeId: 'string',
    serviceAreaId: 'array',
    statusId: 'array',
    journeyTypeCode: 'array',
    fromDate: 'number',
    toDate: 'number',
    sortBy: 'string',
    vehicleTypeId: 'array',
    nextAvailableTime: 'number',
    serviceTypeId: 'array'
  };
  gridColumn: any;
  assignHeader;
  message: Message[] = [];
  columns: any = [];
  params: any = '';
  exportUrl = '';
  printUrl = '';
  statusListToChange = [];
  statusListFilterOptions = [];
  statusDropdownOptions = [];
  recordCount = 0;
  bookingCancelsPopup = false;
  selectParkingLocationHeader;
  yearRange = AppSettings.YEAR_RANGE_SELECTION;
  textToprint = '';
  hasShowDriverSideBar = false;
  bookingDetails;
  uniqId = AppSettings.UNIQID.SHARED_CRITIC_JOURNE_694D;
  dateRange;
  minDate: Date = null;
  maxDate: Date = new Date();
  fromDate = null;
  toDate = null;
  fromDateMilliSeconds: any = '';
  toDateMilliSeconds: any = '';
  dispatchLocations: any = [];
  dispatchPostData: any = {};
  selectedBookingId;
  locationCategoryId;
  selectedLocationId;
  msgs: Message[] = [];
  driverList = [];
  companyOptions = [];
  searchPlaceHolder;
  dateRangePlaceHolder;
  pickupDropPlaceHolder;
  fromDatePlaceHolder;
  toDatePlaceHolder;
  pickupLocationsOptions: any[] = [];
  locationList: any[] = [];
  dropLocationsOptions: any[] = [];
  serviceCitiesOptions: any[];
  passengerTypeOptions: any[];
  selectedPickupLocation: any = [];
  selectedDropLocation: any = [];
  selectedPassengerType;
  selectedBookingStatus = [];
  selectedDispatchAddress: any = [];
  selectedJourneyType;
  subBookingType = undefined;
  _broadSub
  paginationCount = AppSettings.BOOKING_DEFAULT_PAGINATION;
  journeyTypeOptions;
  sortTypeOptions = AppSettings.BOOKING_SORT_BY_TIME_OPTIONS;
  selectedSortType: String = AppSettings.BOOKING_SORT_BY_TIME_OPTIONS[0].value;
  changeBookingStatusAllow: Boolean = true;
  parkingLocationUpdateAllow: Boolean = true;
  collapsed = false;
  originalFilterData: any;
  changedFilterData: any;
  filterButtonClass = 'filter-btn-apply';
  filterApplied = false;
  gridScrollHeight = '';
  THIRD_PARTY_BOOKING_STATUS_CODES_OPTIONS = AppSettings.THIRD_PARTY_BOOKING_STATUS_CODES_OPTIONS;

  cancellationReason: boolean = false;
  label_luggage_booking_cancellation: any;
  bookingCancel: string = '';
  showRadioBtn: Boolean = false;
  id: any;
  vehicleTypeOptions: any[] = [];
  selectedVehicleTypeId: any = [];
  eventIdParam: any;
  bookingInfo: any;
  currentRoute: string;
  nextAvailableTime: any;
  showETAFilter: Boolean = false;
  etaTimeOptions = AppSettings.ETA_TIME_OPTIONS;
  selectedBookingToCancel: any[] = [];
  bookingId: any;
  bookingToCancel: any;
  showCustomDialog: boolean;
  disabledBookingValues = [75, 120, 130, 140];
  showHideSelectAll: boolean = false;
  showCancellationReasonPopup: boolean = false;
  selectedBookingForCancellation = '';
  isReview: Boolean = false;
  passengerRequestCount: any = 1;
  luggageRequestCount: any = 0;
  loading: boolean = false;
  defaultNullString = "NA";
  approve: any = "true";
  decline: any = null;
  isSubmitting: boolean = false;
  dateFormat: any;
  loadGrid = signal(false);

  constructor(
    private router: Router,
    private commonBindingDataService: CommonBindingDataService,
    private userCommonService: UserCommonService,
    private confirmationService: ConfirmationService,
    private uiService: UiService,
    private storageService: StorageService,
    private pickupLocationOptionsService: PickupLocationOptionsService,
    private bookingService: BookingService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.commonBindingDataService.previousScrollTop = '';
    this.changeBookingStatusAllow =
      this.commonBindingDataService.hasLogicalAccessPresent('UPDATE_JOURNEY_STATUS', 'CURRENT_BOOKINGS');
    this.parkingLocationUpdateAllow =
      this.commonBindingDataService.hasLogicalAccessPresent('UPDATE_JOURNEY_PARKING_LOCATION', 'CURRENT_BOOKINGS');
    this.statusListToChange = AppSettings.BOOKING_STATUS_CODES_OPTIONS;
    this.statusDropdownOptions = this.statusListToChange;
    this.statusListFilterOptions = AppSettings.BOOKING_STATUS_CODES_FILTER_OPTIONS;

    this.currentRoute = this.router.url.split('/')[2];
    this.commonBindingDataService.bookingTabCountChange.next(true);
    this.selectParkingLocationHeader = this.commonBindingDataService.getLabel('label_select_parking_location');
    if (this.commonBindingDataService.hasLogicalAccessPresent('CURRENT_BOOKING_EXPORT_CURRENT_BOOKINGS_EXCEL', 'CURRENT_BOOKINGS')) {
      this.exportUrl = '/secure/tour/list/data/export/xls';
    }

    if (this.commonBindingDataService.hasLogicalAccessPresent('BOOKINGS_EXPORT_IN_PDF', 'CURRENT_BOOKINGS')) {
      this.printUrl = '/secure/booking/list/data/export/pdf';
    }

    this._broadSub = this.commonBindingDataService.bookingGridRefresh.subscribe((result) => {
      if (result === AppSettings.SUB_BOOKINMG_SERVICE_TYPES_LIST.CRITICAL) {
        this.gridRef2.refreshList();
      }
    });

    this.searchPlaceHolder = this.commonBindingDataService.getLabel('label_search_by_passenger_barcode_journey_id');
    this.dateRangePlaceHolder = this.commonBindingDataService.getLabel('label_from_to_todate');
    this.pickupDropPlaceHolder = this.commonBindingDataService.getLabel('All');
    this.fromDatePlaceHolder = this.commonBindingDataService.getLabel('label_from_date');
    this.toDatePlaceHolder = this.commonBindingDataService.getLabel('label_to_date');
    this.dateFormat = this.commonBindingDataService.getDateFormat();
    this.companyOptions = [
      {
        label: this.commonBindingDataService.getLabel('label_all'),
        value: ''
      }];

    const storedEventId = this.storageService.getItemFromSessionStorage('storedEventId');
    if (storedEventId) {
      this.eventIdParam = storedEventId;
    }

    if (!this.eventIdParam) {
      const tempEventId = this.commonBindingDataService.changedEventId;
      if (tempEventId) {
        this.eventIdParam = tempEventId;
      }
    }

    if (this.eventIdParam) {
      this.loadInitialData();
    }

    this.commonBindingDataService.eventId.subscribe(result => {
      this.eventIdParam = result;
      this.loadInitialData();
    });

    this.getColumns();
  }

  loadInitialData() {
    this.getVehicleTypes();
    this.prepareJourneyTypeOptions();
    this.getPassengerTypeList();
    this.getServiceCityList();
  }

  getColumns() {
    this.columns.push({
      field: 'bookingCode', width: 80, header: this.commonBindingDataService.getLabel('label_booking_ID'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.commonBindingDataService.getBookingCode(i)),
    });
    this.columns.push({
      field: 'pickupDateTimeStr', width: 70, header: this.commonBindingDataService.getLabel('label_pickup_at'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.firstCell(i)),
    });
    this.columns.push({
      field: 'pFirstName', width: 100, header: this.commonBindingDataService.getLabel('grid_passenger'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.getPassengerName(i)),
    });
    this.columns.push({
      field: 'pickupLocationName', width: 120, header: this.commonBindingDataService.getLabel('grid_pickup_drop_off'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.commonBindingDataService.getPickDropLocation(i)),
    });
    this.columns.push({
      field: 'Info', width: 100, header: this.commonBindingDataService.getLabel('label_driver_info'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.commonBindingDataService.getDriver(i)),
    });
    this.columns.push({
      field: 'bookingStatus', header: this.commonBindingDataService.getLabel('label_status'),
      sort: false, resize: true, isDropDown: true, isEditField: true, isEditIcon: this.parkingLocationUpdateAllow,
      noteText: 'bookingStatus', locationId: 'displayAddress', pickUpEtaStr: 'pickUpEtaStr', estimatedDropOffTimeStr: 'estimatedDropOffTimeStr', etaDistanceString: 'etaDistanceString',
      departureDateTime: 'departureDateTime', dropdownCount: 1, width: 140, flightDetailsNote: 'flightDetailsNote',
      editConditionField: 'driverId', options: this.statusDropdownOptions,
      serviceAreaId: 'tenantServiceAreaId', disabled: !this.changeBookingStatusAllow,
      bookingStatus: 'bookingStatus', subServiceType: 'subServiceType', thirdPartyOptions: this.THIRD_PARTY_BOOKING_STATUS_CODES_OPTIONS,
      borderClass: 'border-class'
    });

    if (this.commonBindingDataService.hasLogicalAccessPresent('ASSIGN_DRIVER_TO_JOURNEY', 'CURRENT_BOOKINGS')) {
      this.columns.push({
        field: '', header: this.commonBindingDataService.getLabel('label_action'),
        sort: false, resize: true, cellRendererHtml: (i) => (this.actionCells(i)), width: 100
      });
    }
  }

  getVehicleTypes() {
    this.vehicleTypeOptions = [];
    const vehicleTypeData: any[] = this.storageService.getItemFromSessionStorage(AppSettings.VEHICLE_TYPE_DATA);
    vehicleTypeData.forEach(element => {
      this.vehicleTypeOptions.push({ label: element.vehicleType, value: element.id });
    });
  }

  initializeUrl() {
    let filterData = this.gateAllFilters();
    if (filterData) {
      let localData = filterData.filterData;
      this.collapsed = (localData.opencloseFilter) ? ((localData.opencloseFilter.toString() === 'true') ? true : false) : false;
      this.gridScrollHeight = this.collapsed ? 'calc(100vh - 280px)' : 'calc(100vh - 400px)';
      this.selectedPickupLocation = localData.selectedPickupLocation ? localData.selectedPickupLocation?.split(',') : [];
      this.selectedDropLocation = localData.selectedDropLocation ? localData.selectedDropLocation?.split(',') : [];
      this.selectedPassengerType = localData.selectedPassengerType ? localData.selectedPassengerType : '';
      if (filterData.filterData.selectedDispatchAddress) {
        this.selectedDispatchAddress = filterData.filterData.selectedDispatchAddress.split(',').map(item => item.trim())?.filter(id =>
          this.serviceCitiesOptions?.some(city => city.value === id)
        );
      } else {
        this.selectedDispatchAddress = [];
      }
      this.getPickupAddress();
      this.selectedJourneyType = localData.selectedJourneyType ? localData.selectedJourneyType : '';
      this.selectedSortType = localData.selectedSortType ? localData.selectedSortType : this.selectedSortType;
      this.nextAvailableTime = localData.nextAvailableTime ? localData.nextAvailableTime : this.nextAvailableTime;
      this.selectedVehicleTypeId = localData.selectedVehicleTypeId ? localData.selectedVehicleTypeId?.split(',') : [];
      this.selectedBookingStatus = localData.selectedBookingStatus ? JSON.parse('[' + localData.selectedBookingStatus + ']') : [];

      if (this.selectedSortType === 'eta') {
        this.showETAFilter = true
      }

      const timeZone: string = this.storageService.getItemFromSessionStorage('storedTimezone');

      if (localData.fromDateMilliSeconds) {
        const fromDateInTimeZone = moment.tz(+localData.fromDateMilliSeconds, timeZone).startOf('day');
        this.fromDateMilliSeconds = fromDateInTimeZone.valueOf();
        this.fromDate = fromDateInTimeZone.toDate();
      } else {
        this.fromDateMilliSeconds = '';
        this.fromDate = null;
      }

      if (localData.toDateMilliSeconds) {
        const toDateInTimeZone = moment.tz(+localData.toDateMilliSeconds, timeZone).endOf('day').subtract(1, 'second');
        this.toDateMilliSeconds = toDateInTimeZone.valueOf();
        this.toDate = toDateInTimeZone.toDate();
      } else {
        this.toDateMilliSeconds = '';
        this.toDate = null;
      }
      this.url = `${this.tempUrl}&pickupAddressId=${this.selectedPickupLocation}&dropAddressId=${this.selectedDropLocation}` +
        `&passengerTypeId=${this.selectedPassengerType}&serviceAreaId=${this.selectedDispatchAddress}` +
        `&statusId=${this.selectedBookingStatus}&journeyTypeCode=${this.selectedJourneyType}` +
        `&fromDate=${this.fromDateMilliSeconds}&toDate=${this.toDateMilliSeconds}&sortBy=${this.selectedSortType}&vehicleTypeId=${this.selectedVehicleTypeId}&nextAvailableTime=${this.nextAvailableTime ? this.nextAvailableTime : 0}`;
    } else {
      this.url = this.tempUrl + `&sortBy=${this.selectedSortType}`;
    }
    this.loadGrid.set(true);
    this.gateAndSetAllFilters();
  }

  prepareJourneyTypeOptions() {
    const firstPart = Object.assign([], AppSettings.JOURNEY_TYPES_TO_SHOW);
    this.journeyTypeOptions = firstPart;
    this.journeyTypeOptions.unshift({ label: this.commonBindingDataService.getLabel('label_all'), value: '' });
  }

  getRequestedVehicleType(params) {
    const eDiv = document.createElement('div');
    let requestedVT = `<div title="${params.vehicleType}" style="text-align:center;">${params.vehicleType}</div>`
    eDiv.innerHTML += requestedVT;
    return eDiv;
  }

  firstCell(params) {
    const eDiv = document.createElement('div');
    const lblStatus = `<div class="booking-grid-table">
      <div class = "pickup-time">` + params.pickupTimeStr + `</div>
      <div class = "pickup-date">` + params.pickupDateStr + `</div>
       ${params.stopOneAddress && params.stopOneLatitude && params.stopOneLongitude ? `<div class='multi-stop mt-2' title="${params.stopOneAddress}">Additional Stop</div>` : ''}
    </div>`;
    eDiv.innerHTML += lblStatus;
    return eDiv;
  }

  getPassengerName(params) {
    const firstName = params.firstName ? params.firstName : '--';
    const lastName = params.lastName ? params.lastName : '--';
    const priority = params.passengerType ? params.passengerType : '';
    const passengerCount = params.totalNoOfPassengers;
    const eDiv = document.createElement('div');
    let preparedData = '';
    let preparedData1 = '';
    const passengerInfoHtml = params.luggageTour ? `<div class = "pickup-date drop-adr pass-info passenger passengerInfo pb-2">${params.luggageTour ? (params.luggageWithTotalNoOfBagsString ? params.luggageWithTotalNoOfBagsString : '') : ''}</div>` :
      `<div title="${passengerCount} Pass ${params.totalNoOfBabyseats > 0 ? `| ${params.totalNoOfBabyseats}C` : ''} ${params.totalNoOfWheelchairs > 0 ? ` | ${params.totalNoOfWheelchairs}W` : ''} ${params.totalNoOfLuggageBagsString ? `| ${params.totalNoOfLuggageBagsString}` : ''}" class="pickup-date drop-adr pass-info passenger passengerInfo pb-2">${passengerCount} Pass <span class="child-seat">
      ${params.totalNoOfBabyseats > 0 ? `| ${params.totalNoOfBabyseats}C` : ''}
      ${params.totalNoOfWheelchairs > 0 ? ` | ${params.totalNoOfWheelchairs}W` : ''}
      ${params.totalNoOfLuggageBagsString ? `| ${params.totalNoOfLuggageBagsString}` : ''}
    </span></div>`;
    if (params.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.GENERAL ||
      params.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.SPECIAL_EVENT ||
      params.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.THIRD_PARTY) {
      preparedData1 = `<div class="booking-grid-table" title="">
        <div class="passenger-name passengerName" title="${firstName} ${lastName}">` + firstName + `&nbsp` + lastName + `</div>
        <div class="passengerType my-2" title="${priority}">${priority}</div>
      </div>`;
      preparedData = passengerInfoHtml;
    } else if (params.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.SHUTTLE) {
      preparedData = `<div class="booking-grid-table">
      <div class = "passenger-name passengerName" title="${params.tripTitle}">` + params.tripTitle + `</div>
      ${passengerInfoHtml}
      </div>`;
    } else if (params.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.VEHICLE_TRANSFER) {
      preparedData = `<div class="booking-grid-table" title="${this.commonBindingDataService.getLabel('VEHICLE TRANSFER')}">
      <div class = "passenger-name passengerName">` + this.commonBindingDataService.getLabel('VEHICLE TRANSFER') + `</div>
      </div>`;
    }
    eDiv.innerHTML += preparedData1;
    eDiv.innerHTML += preparedData
    return eDiv;
  }

  getPickDropLocation(params) {
    params.BookingStatusPrevious = params.bookingStatus;
    const eDiv = document.createElement('div');
    const addressInstructions = this.prepareNote(params);
    const PreparedData = `
    <div style="margin-top: -13px;margin-bottom: -4px;">
    <div class="col-12 booking-grid-table booking-details pad-top" title="">
    <div clas="col-12">
      <div class="col-1 md:col-1 lg:col-2 passenger-name address-container">
        <div class="start-point-new"><img src="/assets/images/temp/pickup.png"></div>
        <div class="divider"></div>
        <div class="end-point-new"><img src="/assets/images/temp/drop-off.png"></div>
      </div>
      <div class="col-10 md:col-10 lg:col-10 passenger-name">
        <div class="passenger-name" title="${params.pickupLocationName}">` + params.pickupLocationName + `</div>
        <div class="pickup-date drop-adr opa-9" title="${params.dropLocationName}">` + params.dropLocationName + `</div>
      </div>
    </div>` + ((params.tripNote || params.passengerNote || params.passengerStayAddressNote) ? `
    <div clas="col-12" style="margin-top: -5px;">
      <span class="address-instrn" title="${addressInstructions}"><img src="/assets/images/temp/info-icon.svg"></span>
    </div>` : '') +
      `</div></div>`;

    eDiv.innerHTML += PreparedData;
    return eDiv;
  }

  prepareNote(params) {
    let totalNote = '';
    if (params.tripNote) {
      totalNote += `Booking note: ${params.tripNote}&#013;&#010;&#013;&#010;`;
      totalNote = totalNote.replace(/["]/g, '');
    }
    if (params.passengerNote) {
      totalNote += `Passenger note: ${params.passengerNote}&#013;&#010;&#013;&#010;`;
      totalNote = totalNote.replace(/["]/g, '');
    }
    if (params.passengerStayAddressNote) {
      totalNote += `Address note: ${params.passengerStayAddressNote}&#013;&#010;&#013;&#010;`;
      totalNote = totalNote.replace(/["]/g, '');
    }
    return totalNote;
  }

  getInfo(params) {
    const passengerCount = params.totalNoOfPassengers;
    params.BookingStatusPrevious = params.bookingStatus;
    const seatLetters = this.getChildLetters(params);
    const eDiv = document.createElement('div');
    const PreparedData = `<div class="booking-grid-table" title="">
    <div class = "pickup-time">${passengerCount}<span class = "info-span">Pass</span></div>
    <div class = "pickup-date info-lower-div">${seatLetters}</div>
    </div>`;
    eDiv.innerHTML += PreparedData;
    return eDiv;
  }

  getvehicle(params) {
    const eDiv = document.createElement('div');
    const PreparedData = `<div class="booking-grid-table" title="${params.vehicleType}">
    <div class = "pickup-time"><span>${params.vehicleType}</span></div>
    </div>`;
    eDiv.innerHTML += PreparedData;
    return eDiv;
  }

  getDriver(params) {
    const driverName = params.driverName ? params.driverName : '';
    const driverVehicleType = params.driverVehicleType ? params.driverVehicleType : '';
    const vehicleRegistration = params.vehicleCode ? params.vehicleCode : '';

    const eDiv = document.createElement('div');
    const PreparedData = `<div class="booking-grid-table gid" title="">
    <div class = "passenger-name">${driverName}</div>
    <div class = "pickup-date drop-adr pass-info vehicle">${driverVehicleType}-${vehicleRegistration}</div>
    </div>`;
    let returnString = params.driverVehicleType ? PreparedData : 'NA'
    eDiv.innerHTML += returnString;
    return eDiv;
  }

  getChildLetters(params) {
    const childSeats = (params.totalNoOfChildseats) ? params.totalNoOfChildseats : 0;
    const babyseat = (params.totalNoOfBabyseats) ? params.totalNoOfBabyseats : 0;
    const wheelchair = (params.totalNoOfWheelchairs) ? params.totalNoOfWheelchairs : 0;
    let requiredString = '';

    for (let eachSeat = 0; eachSeat < wheelchair; eachSeat++) {
      requiredString += 'W';
    }
    for (let eachSeat = 0; eachSeat < babyseat; eachSeat++) {
      requiredString += 'B';
    }
    for (let eachSeat = 0; eachSeat < childSeats; eachSeat++) {
      requiredString += 'C';
    }
    return requiredString;
  }

  actionCells(params) {
    if (params.subServiceTypeStatus === AppSettings.SUB_BOOKINMG_SERVICE_TYPES.INBOUND ||
      params.subServiceTypeStatus === AppSettings.SUB_BOOKINMG_SERVICE_TYPES.OUTBOUND ||
      params.subServiceTypeStatus === AppSettings.SUB_BOOKINMG_SERVICE_TYPES.OTHER) {

      let assignType = 'assignDriver';
      let assignIcon = '/assets/images/temp/icon-assign-grid.svg';
      let isEnabled = true;
      let isReassign = false;
      
      if (params.driverId) {
        isEnabled = this.checkIfReassignable(params, 'grey') === true;
        assignType = 'reAssignDriver';
        assignIcon = '/assets/images/temp/icon-reassign-grid.svg';
        isReassign = true;
      } else {
        isEnabled = AppSettings.DRIVER_ASSIGN_CONDITIONS.indexOf(params.bookingStatus) > -1;
      }

      if (params.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.THIRD_PARTY) {
        isEnabled = this.checkIfReassignable(params, 'grey') === true;
        assignType = 'reAssignDriver';
        assignIcon = '/assets/images/temp/icon-reassign-grid.svg';
        isReassign = true;
      }

      let buttonLabel = '';
      let showIcon = true;
      
      if (params.subServiceType == "VEHICLE_TRANSFER") {
        assignType = 'assignDrivers';
        assignIcon = '/assets/images/temp/icon-reassign-grid.svg';
        isEnabled = true;
        buttonLabel = this.commonBindingDataService.getLabel('label_view_details');
        showIcon = false;
      }

      if (params.luggageTourAction === 'new' && (params.requestLabelType == 'MULTIPLE_VEHICLE_WITH_LUGGAGE_REQUEST' || params.requestLabelType == 'LUGGAGE_REQUEST' || params.requestLabelType == 'MULTIPLE_VEHICLE_REQUEST')) {
        assignType = 'reviewButton';
        assignIcon = '/assets/images/temp/icon-review-grid.svg';
        isEnabled = true;
      }

      const eDiv = document.createElement('div');
      eDiv.setAttribute('class', 'grid-btn-div buttons action-buttons-container');
      
      let assignReassignBtn = '';
      if (showIcon) {
        const disabledClass = isEnabled ? '' : ' disabled';
        const reassignClass = isReassign ? ' reassign-icon' : '';
        const hasNextButton = params.showMergeButton === true || params.showUnmergeButton === true;
        const marginStyle = hasNextButton ? 'margin-right: 12px;' : '';
        let tooltipText = 'Assign';
        if (isReassign) {
          tooltipText = 'Reassign';
        } else if (assignType === 'reviewButton') {
          tooltipText = 'Review';
        }
        assignReassignBtn = `<div data-action-type=${assignType} class="grid-btn-div grid-action-icon-btn${disabledClass}${reassignClass}" style="${marginStyle}" title="${tooltipText}">
           <img src="${assignIcon}" alt="Assign" />
        </div>`;
      } else {
        const disabledClass = isEnabled ? '' : ' disabled';
        const hasNextButton = params.showMergeButton === true || params.showUnmergeButton === true;
        const marginStyle = hasNextButton ? 'margin-right: 12px;' : '';
        assignReassignBtn = `<div data-action-type=${assignType} class="grid-btn-div re-assign-btn${disabledClass}" style="${marginStyle}" title="${buttonLabel}">
           ${buttonLabel}
        </div>`;
      }
      
      let mergeBtn = '';
      if (params.showMergeButton === true) {
        const hasNextButton = params.showUnmergeButton === true;
        const marginStyle = hasNextButton ? 'margin-right: 12px;' : '';
        mergeBtn = `<div data-action-type="mergeBooking" class="grid-btn-div grid-action-icon-btn" style="${marginStyle}" title="Merge">
           <img src="/assets/images/temp/merge-grid.svg" alt="Merge" />
        </div>`;
      }
      
      let unmergeBtn = '';
      if (params.showUnmergeButton === true) {
        unmergeBtn = `<div data-action-type="unmergeBooking" class="grid-btn-div grid-action-icon-btn" title="Unmerge">
           <img src="/assets/images/temp/unmerge-grid.svg" alt="Unmerge" />
        </div>`;
      }
      
      eDiv.innerHTML = assignReassignBtn + mergeBtn + unmergeBtn;
      
      const actionButtons = eDiv.querySelectorAll('[data-action-type]');
      actionButtons.forEach(button => {
        const element = button as HTMLElement;
        element.setAttribute('data-row-id', params.id);
      const isDisabled = element.classList.contains('disabled');
      if (isDisabled) {
        element.style.pointerEvents = 'auto';
        element.style.cursor = 'not-allowed';
        element.setAttribute('aria-disabled', 'true');
        return;
      }

      element.style.pointerEvents = 'auto';
      element.style.cursor = 'pointer';
      element.removeAttribute('aria-disabled');

      const actionType = element.getAttribute('data-action-type');
        const rowData = params;
        
        const handleActionClick = (event: Event) => {
          const mouseEvent = event as MouseEvent;
          mouseEvent.stopImmediatePropagation();
          mouseEvent.stopPropagation();
          mouseEvent.preventDefault();
          if (actionType) {
            this.handleActionDirectly(actionType, rowData);
          }
          return false;
        };
        
        element.addEventListener('click', handleActionClick, { capture: true, passive: false });
      });
      
      return eDiv;
    } else {
      const eDiv = document.createElement('div');
      eDiv.innerHTML = '';
      return eDiv;
    }
  }

  getLatestEta(event) {
    this.commonBindingDataService.getETA(event.row.id).subscribe(results => {
      this.uiService.showMessage('ETA Updated Successfully.', 'success');
      let ele = document.getElementById(event.row.id) as HTMLElement;
      ele.innerHTML = "Loading...";
      this.refreshGrid();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  reloadGrid() {
    setTimeout(() => {
      this.commonBindingDataService.bookingTabCountChange.next(true);
    }, 1000);
    this.gridRef2.updateUrl(this.tempUrl + this.params);
  }

  refreshGrid() {
    this.gridRef2.refreshList();
  }

  goToManualBookingPage() {
    this.router.navigate(['bookings/manual-booking']);
  }

  onclickFilterApply() {
    this.applyFilter();
  }

  applyFilter() {
    this.params = '';
   if (this.fromDate !== undefined) {
      const timeZone: string = this.storageService.getItemFromSessionStorage('storedTimezone');
      // Set the fromDate to midnight in the selected timezone
      const fromDateWithTimeZone = moment.tz(this.fromDate, timeZone).startOf('day');

      this.fromDateMilliSeconds = fromDateWithTimeZone.valueOf();
      this.params += ('&fromDate=' + this.fromDateMilliSeconds);
    }
    if (this.toDate !== undefined) {
      const timeZone: string = this.storageService.getItemFromSessionStorage('storedTimezone');
      // Set the toDate to midnight in the selected timezone
      const toDateWithTimeZone = moment.tz(this.toDate, timeZone).endOf('day').subtract(1, 'second');
      this.toDateMilliSeconds = toDateWithTimeZone.valueOf();
      this.params += ('&toDate=' + this.toDateMilliSeconds);
    }
    if (this.selectedPickupLocation !== undefined && this.selectedPickupLocation !== null) {
      this.params += (`&pickupAddressId=${this.selectedPickupLocation}`);
    }
    if (this.selectedDropLocation !== undefined && this.selectedDropLocation !== null) {
      this.params += (`&dropAddressId=${this.selectedDropLocation}`);
    }
    if (this.selectedPassengerType !== undefined && this.selectedPassengerType !== null) {
      this.params += (`&passengerTypeId=${this.selectedPassengerType}`);
    }
    if (this.selectedDispatchAddress !== undefined && this.selectedDispatchAddress !== null) {
      this.params += (`&serviceAreaId=${this.selectedDispatchAddress}`);
    }
    if (this.selectedBookingStatus !== undefined && this.selectedBookingStatus !== null) {
      this.params += (`&statusId=${this.selectedBookingStatus}`);
    }
    if (this.selectedJourneyType !== undefined && this.selectedJourneyType !== null) {
      this.params += (`&journeyTypeCode=${this.selectedJourneyType}`);
    }
    if (this.selectedSortType !== undefined && this.selectedSortType !== null) {
      this.params += (`&sortBy=${this.selectedSortType}`);
    }
    if (this.selectedVehicleTypeId !== undefined && this.selectedVehicleTypeId !== null) {
      this.params += (`&vehicleTypeId=${this.selectedVehicleTypeId}`);
    }
    if (this.nextAvailableTime !== undefined && this.nextAvailableTime !== null) {
      this.params += (`&nextAvailableTime=${this.nextAvailableTime}`);
    }
    this.reloadGrid();
    this.updateSaveFilter();
    this.filterApplied = false;
  }

  resetFilter() {
    this.fromDate = null;
    this.toDate = null;
    this.fromDateMilliSeconds = '',
      this.toDateMilliSeconds = '',
      this.dateRange = null;
    this.selectedPickupLocation = [];
    this.selectedDropLocation = [];
    this.selectedPassengerType = null;
    this.selectedDispatchAddress = [];
    this.selectedJourneyType = null;
    this.selectedBookingStatus = [];
    this.selectedVehicleTypeId = [];
    this.selectedSortType = AppSettings.BOOKING_SORT_BY_TIME_OPTIONS[0].value;
    this.params = '';
    this.minDate = null;
    this.maxDate = new Date();
    this.nextAvailableTime = null;
    this.showETAFilter = false;
    this.reloadGrid();
    this.updateSaveFilter();
    this.getPickupAddress();
  }

  updateSaveFilter() {
    const saveFilterModel = new CriticalScreenFilterModel({
      screenCode: AppSettings.FILTER_SCREEN_CODE.CRITICAL_SCREEN,
      eventId: this.userCommonService.getActiveEventId(),
      filterData: new CriticalScreenFiltersDataModel({
        selectedPickupLocation: this.selectedPickupLocation.toString(),
        selectedDropLocation: this.selectedDropLocation.toString(),
        fromDateMilliSeconds: this.fromDateMilliSeconds,
        toDateMilliSeconds: this.toDateMilliSeconds,
        selectedPassengerType: this.selectedPassengerType,
        selectedDispatchAddress: this.selectedDispatchAddress.toString(),
        selectedBookingStatus: this.selectedBookingStatus.toString(),
        selectedJourneyType: this.selectedJourneyType,
        selectedSortType: this.selectedSortType,
        nextAvailableTime: this.nextAvailableTime,
        opencloseFilter: this.collapsed,
        selectedVehicleTypeId: this.selectedVehicleTypeId.toString(),
      }),
    });

    this.userCommonService.updateSavedFilter(saveFilterModel).subscribe(result => {
      this.userCommonService.updateFilterDataToLocal(result);
      setTimeout(() => {
        this.gateAndSetAllFilters();
      }, 100);
      this.filterApplied = false;
    }, (error) => {
    });
  }

  changeDispatchLocation(event) {
    if (this.commonBindingDataService.checkIsEditable(event.data.bookingStatus)) {
      this.dispatchLocations = [];
      this.selectedBookingId = event.data.id;
      this.selectedLocationId = event.data.locationId;
      if (this.userCommonService.userMetaData.locationCategorisList) {
        this.userCommonService.userMetaData.locationCategorisList.map(ele => {
          if (ele.id === AppSettings.LOCATION_TYPES.PARKING) {
            this.locationCategoryId = ele.id;
            this.commonBindingDataService.getDispatchQueueLocations('non-grid',
              this.locationCategoryId, this.selectedBookingId, 'true', this.eventIdParam).subscribe(result => {
                if (result) {
                  this.dispatchLocations = result;
                  this.cdr.detectChanges();
                }
              })
          }
        });
      }
      this.bookingCancelsPopup = true;
    }
  }

  onSelectDispatchLocation(locationInfo) {
    this.dispatchPostData = {
      'tourId': this.selectedBookingId,
      'locationId': locationInfo.id,
      'eta': locationInfo.eta,
      'distance': locationInfo.distance,
    }
    this.commonBindingDataService.setDispatchLocation(this.dispatchPostData).subscribe(result => {
      if (result) {
        this.uiService.showMessage(result.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
        this.refreshGrid();
        this.bookingCancelsPopup = false;
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
    })
  }

  changeBookingStatus(event) {
    switch (event.value) {
      case AppSettings.BOOKING_STATUS_CODES.NEW_REQUEST:
        this.statusChangeToNewRequest(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.ADMIN_CONFIRMED:
        this.statusChangeToAdminConfirmed(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.DRIVER_CONFIRMED:
        this.statusChangeToDriverConfirmed(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.DRIVER_RECONFIRM:
        this.statusChangeToAccept(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.DRIVER_ON_THE_WAY:
        this.statusDriverOnTheWay(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.DRIVER_ARRIVED:
        this.statusDriverArrived(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.ON_TRIP:
        this.statusOnTrip(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.EXPIRED:
        this.statusExpired(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.CANCELED:
        this.statusCanceledV1(event);
        break;
      case AppSettings.BOOKING_STATUS_CODES.COMPLETED:
        this.statusCompleted(event);
        break;
      default:
        break;
    }
  }

  statusChangeToNewRequest(event) {
    const data = { tourStatus: AppSettings.BOOKING_STATUS_CODES.NEW_REQUEST, tenantId: AppSettings.TENANT }
    this.commonBindingDataService.changeBackToNewRequest(event.data.id, data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.refreshGrid();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusChangeToAdminConfirmed(event) {
    const data = { 'tourStatusCode': AppSettings.BOOKING_STATUS_CODES.ADMIN_CONFIRMED }
    this.commonBindingDataService.adminConfirmed(event.data.id, data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.refreshGrid();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusChangeToDriverConfirmed(event) {
    const data = { 'tourStatusCode': AppSettings.BOOKING_STATUS_CODES.DRIVER_CONFIRMED }
    this.commonBindingDataService.driverFirstConfirmed(event.data.id, data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.refreshGrid();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusChangeToAccept(event) {
    const data = {
      "actionTakenOnAddress": "",
      "actionTakenOnAddressLatitude": 0.0,
      "actionTakenOnAddressLongitude": 0.0,
      "luggageTour": false,
      "eventId": this.eventIdParam
    }
    this.commonBindingDataService.acknowledgeTrip(event.data.id, data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.refreshGrid();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusDriverOnTheWay(event) {
    const data = {
      "actionTakenOnAddress": "",
      "actionTakenOnAddressLatitude": 0.0,
      "actionTakenOnAddressLongitude": 0.0,
      "luggageTour": false,
      "eventId": this.eventIdParam
    }
    this.commonBindingDataService.driverOntheWay(event.data.id, data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.refreshGrid();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusDriverArrived(event) {
    const data = {
      "actionTakenOnAddress": "",
      "actionTakenOnAddressLatitude": 0.0,
      "actionTakenOnAddressLongitude": 0.0,
      "luggageTour": false,
      "eventId": this.eventIdParam
    }
    this.commonBindingDataService.driverArrived(event.data.id, data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.refreshGrid();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusOnTrip(event) {
    this.message = [];
    const tripStartData = {
      "actionTakenOnAddress": "",
      "actionTakenOnAddressLatitude": 0.0,
      "actionTakenOnAddressLongitude": 0.0,
      "luggageTour": false,
      "eventId": this.eventIdParam
    };
    this.commonBindingDataService.startTrip(tripStartData, event.data.id).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.refreshGrid();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusCompleted(event) {
    if (event.data.subServiceType === AppSettings.JOURNEY_TYPE_VALUES.THIRD_PARTY) {
      if (event.data.BookingStatusPrevious !== AppSettings.BOOKING_STATUS_CODES.DRIVER_RECONFIRM) {
        this.uiService.showMessage(this.commonBindingDataService.getLabel('error_status_change_fail'), AppSettings.MESSAGE_TYPE.ERROR);
        this.refreshGrid();
        return;
      }
    }

    const chargeData = [];
    const data = {
      tourId: event.data.id,
      manualDistanceByAdmin: '',
      time: '',
      dropLocationName: '',
      endTripLatitude: event.sourceLatitude,
      endTripLongitude: event.sourceLongitude,
      inputTourAdditionalReasonList: chargeData,
      "actionTakenOnAddress": "",
      "actionTakenOnAddressLatitude": 0.0,
      "actionTakenOnAddressLongitude": 0.0
    };
    this.commonBindingDataService.dropTrip(data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.refreshGrid();
      this.commonBindingDataService.bookingTabCountChange.next(true);
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  statusExpired(event) {
    this.refreshGrid();
  }

  statusCanceledV1(event: any) {
    this.selectedBookingForCancellation = event.data;
    this.showCancellationReasonPopup = true;
  }

  showBookingsToCancel() {
    this.bookingToCancel = [];
    this.commonBindingDataService.showBookingsToCancel(this.bookingId, this.eventIdParam).subscribe(result => {
      this.bookingToCancel = result.associateBookingsList;
      const disableSelectAll = [];
      const valuesToCheck = [130, 140, 120];

      if (this.bookingToCancel.length > 0) {
        this.bookingToCancel.forEach((element) => {
          disableSelectAll.push(element.tourStatus);
        });
      }

      const foundValues = disableSelectAll.filter(value => valuesToCheck.includes(value));
      this.showHideSelectAll = foundValues.length > 0;

      this.showCustomDialog = true;
      this.cdr.detectChanges();
      const selectedBooking = this.bookingToCancel.find(
        booking => booking.tourId === this.bookingId && !valuesToCheck.includes(booking.tourStatus)
      );

      if (selectedBooking) {
        this.selectedBookingToCancel = [selectedBooking];
      }

    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
    });
  }

  confirmCustomCancellation() {
    if (this.selectedBookingToCancel && this.selectedBookingToCancel.length > 0) {
      const selectedBookingIds = this.selectedBookingToCancel.map(booking => {
        return booking.tourId;
      });
      if (selectedBookingIds && selectedBookingIds.length > 0) {
        const data = {
          cancellationReason: '', // Add reason if needed
          tourIds: selectedBookingIds // Send selected booking IDs
        };
        this.cancelApi(this.bookingId, data);
      } else {
        console.error('No valid booking IDs selected for cancellation');
      }
    } else {
      this.uiService.showMessage('Invalid Action', AppSettings.MESSAGE_TYPE.ERROR);
    }
    this.showCustomDialog = false;
  }
  closeCancellation() {
    this.showCustomDialog = false;
  }
  isBookingDisabled(value: number): boolean {
    return this.disabledBookingValues.includes(value);
  }

  confirmCancellationReason() {
    if (this.showRadioBtn && this.bookingCancel != '' || null || undefined) {
      this.cancellationReason = false;
      const data = {
        cancellationReason: '',
        cancelBooking: this.bookingCancel == "bothBooking" ? 'BOTH' : this.id
      };
      this.cancelApi(this.id, data)
      this.bookingCancel = '';
    } else if (this.showRadioBtn == false) {
      this.cancellationReason = false;
      const data = {
        cancellationReason: '',
        cancelBooking: "BOTH"
      };
      this.cancelApi(this.id, data);
      this.bookingCancel = '';
    } else {
      this.uiService.showMessage("Please select any one option", AppSettings.MESSAGE_TYPE.ERROR);
    }
  }

  closeCancellationReason() {
    this.cancellationReason = false;
    this.showRadioBtn = false;
    this.bookingCancel = '';
  }

  cancelApi(id, data) {
    this.commonBindingDataService.cancelBooking(id, data).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.refreshGrid();
      this.commonBindingDataService.bookingTabCountChange.next(true);
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.refreshGrid();
    });
  }

  getEta(event: any) {
    this.bookingCancelsPopup = true;
  }
  totalCount(event: any) {
    this.recordCount = event;
  }

  getActionTypeFromEvent(event: any): string | null {
    const target = event.target;
    if (!target) return null;
    
    let element: HTMLElement | null = target;
    while (element && element !== document.body) {
      const actionType = element.getAttribute('data-action-type');
      if (actionType) {
        return actionType;
      }
      element = element.parentElement;
    }
    
    if (event.composedPath) {
      const path = event.composedPath();
      for (const pathElement of path) {
        if (pathElement && pathElement.getAttribute) {
          const actionType = pathElement.getAttribute('data-action-type');
          if (actionType) {
            return actionType;
          }
        }
      }
    }
    
    return null;
  }

  handleActionDirectly(actionType: string, data: any) {
    this.subBookingType = data.subServiceTypeStatus;
    switch (actionType) {
      case 'assignDriver':
        this.openSideBar(data);
        return true;
      case 'reAssignDriver':
        return this.checkIfReassignable(data);
      case 'assignDrivers':
        return this.navigateToBookingDetails(data);
      case 'reviewButton':
        this.openReviewPopup(data);
        return true;
      case 'mergeBooking':
        this.commonBindingDataService.openMergePopup(data);
        return true;
      case 'unmergeBooking':
        this.openUnmergePopup(data);
        return true;
      default:
        return undefined;
    }
  }

  private navigateToBookingDetails(data: any) {
    if (this.commonBindingDataService.hasLogicalAccessPresent('VIEW_JOURNEY_DETAILS', 'CURRENT_BOOKINGS')) {
      return this.router.navigate([`bookings/booking-details`], { queryParams: { id: data.id, navigateFrom: 'critical', fromScreen: this.currentRoute } });
    }
    return false;
  }

  onRowClicked(e: any) {
    const actionType = this.getActionTypeFromEvent(e.originalEvent);
    if (actionType) {
      e.originalEvent.stopPropagation();
      e.originalEvent.preventDefault();
      const handled = this.handleActionDirectly(actionType, e.data);
      if (handled !== undefined) {
        return handled;
      }
    }
    return this.navigateToBookingDetails(e.data);
  }

  openReviewPopup(data) {
    this.resetCounters();
    this.bookingDetails = data;
    this.isReview = true;
    this.loading = true; // Start the loader
    this.getBookingDetails();
  }
  onClickBack() {
    this.isReview = false
    this.resetCounters();

  }
  resetCounters() {
    this.passengerRequestCount = 1;
    this.luggageRequestCount = 0;
    this.approve = "true";
    this.decline = null;
  }

  checkIfReassignable(data, background?) {
    if (AppSettings.DRIVER_ASSIGN_CONDITIONS.indexOf(data.bookingStatus) > -1) {
      if (background) {
        return true;
      } else {
        return this.openSideBar(data, 'reasign');
      }
    } else {
      return false;
    }
  }

  openSideBar(data, secondArg?: any) {
    this.bookingDetails = data;
    this.hasShowDriverSideBar = true;
  }

  getBookingDetails() {
    this.bookingService.fetchTourBooking(this.bookingDetails.id, this.eventIdParam, this.fromDate, this.toDate).subscribe(results => {
      this.bookingInfo = results;
      this.loading = false;
      this.cdr.detectChanges();
    }, (error) => {
      this.loading = false;
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
    });
  }
  isPassengerCountClicked(data) {
    if (data === "true") {
      this.approve = "true"
      this.decline = null
    } else if (data === "false") {
      this.approve = null
      this.decline = "false"
    }
  }
  onAddPassenger() {
    if (this.passengerRequestCount > 0 || this.passengerRequestCount <= 2) {
      this.passengerRequestCount = this.passengerRequestCount + 1;
    }
  }

  onRemovePassenger() {
    if (this.passengerRequestCount > 1) {
      this.passengerRequestCount--;
    }
  }

  backNavigate() {
    this.hasShowDriverSideBar = false;
    setTimeout(() => {
      this.gridRef2?.clearRowSelection();
    }, 100);
  }

  isPopCancel(event) {
    this.bookingCancelsPopup = false;
  }

  isPopSave(event) {
    this.bookingCancelsPopup = false;
  }

  selectedClass(params) {
    let returnClass = '';
    if (this.selectedLocationId === params.id) {
      returnClass = 'background-selected';
    }
    return returnClass;
  }

  sideBarHideFromShaired() {
    this.refreshGrid();
    this.hasShowDriverSideBar = false;
    setTimeout(() => {
      this.gridRef2?.clearRowSelection();
    }, 100);
  }

  getPickupAddress() {
    const serviceAreaId = Array.isArray(this.selectedDispatchAddress)
      ? this.selectedDispatchAddress.join(',')
      : String(this.selectedDispatchAddress ?? '');
    const eventId = this.eventIdParam != null ? String(this.eventIdParam) : '';
    this.pickupLocationOptionsService.getPickupAddress(serviceAreaId, eventId).subscribe((results) => {
      this.pickupLocationsOptions = results.map(ele => ({ label: ele.code, value: ele.id }));
    });
  }

  getServiceCityList() {
    this.serviceCitiesOptions = [];
    this.commonBindingDataService.getCitiesV1(this.eventIdParam).subscribe(results => {
      this.serviceCitiesOptions = results.map(element => ({ label: element.cityAliasName, value: element.id }));
      this.initializeUrl();
    }, (error) => {
      error = JSON.parse(error);
    });
  }

  getPassengerTypeList() {
    this.passengerTypeOptions = [];
    this.commonBindingDataService.getPassengerType().subscribe(results => {
      this.passengerTypeOptions = results.data.map(ele => ({ label: ele.passengerType, value: ele.passengerTypeId }));
      this.passengerTypeOptions.unshift({ label: this.commonBindingDataService.getLabel('label_all'), value: '' });
    }, (error) => {
      error = JSON.parse(error);
    });
  }

  //

  onSelectDates(e, from) {
    if (from === 'fromDate') {
      this.minDate = this.fromDate;
      this.changeFilter('fromDateMilliSeconds', this.fromDate.getTime().toString());
    }
    if (from === 'toDate') {
      this.maxDate = this.toDate;
      let finalToTime = this.commonBindingDataService.addLapseTimeInEndDate(this.toDate.getTime());
      this.changeFilter('toDateMilliSeconds', finalToTime.toString());
    }
  }

  onAfterToggle(event?) {
    this.collapsed = event.collapsed;
    this.updateOpenCloseFilter();
    this.gridScrollHeight = this.collapsed ? 'calc(100vh - 280px)' : 'calc(100vh - 400px)';
  }

  updateOpenCloseFilter() {
    const saveFilterModel = {
      screenCode: AppSettings.FILTER_SCREEN_CODE.CRITICAL_SCREEN,
      eventId: this.userCommonService.getActiveEventId(),
      filterData: {
        opencloseFilter: this.collapsed,
      },
    };

    this.userCommonService.updateFilterOpenClose(saveFilterModel, 'opencloseFilter').subscribe(result => {
      this.userCommonService.updateFilterDataToLocal(result, 'opencloseFilter', result.filterData.opencloseFilter);
    }, (error) => {
    });
  }

  // aplly btn  change color start
  gateAndSetAllFilters() {
    this.gateAllFilters();
    this.makeAllFilterToString();
  }

  gateAllFilters() {
    let filterData: CriticalScreenFilterModel = this.userCommonService.getSavedFilters(AppSettings.FILTER_SCREEN_CODE.CRITICAL_SCREEN, this.userCommonService.getActiveEventId());
    if (filterData) {
      let localData = filterData.filterData;
      this.originalFilterData = localData;
      this.changedFilterData = { ...localData };
      return filterData;
    } else {
      setTimeout(() => {
        this.resetFilter();
      }, 100);
    }
  }

  makeAllFilterToString() {
    if (this.originalFilterData) {
      let keys = Object.keys(this.originalFilterData);
      for (let i = 0; i < keys.length; i++) {
        this.changedFilterData[keys[i]] = this.changedFilterData[keys[i]] ? this.changedFilterData[keys[i]] : '';
        this.originalFilterData[keys[i]] = this.originalFilterData[keys[i]] ? this.originalFilterData[keys[i]] : '';
      }
    }
  }

  changeFilter(key?, val?) {
    if (key === "selectedSortType" && val === "eta") {
      this.showETAFilter = true
    } else if (key === "selectedSortType" && val != "eta") {
      this.showETAFilter = false
      this.nextAvailableTime = 0
    }

    this.changedFilterData[key] = val.toString();

    let changedvalus = [];
    let keys = Object.keys(this.originalFilterData);
    for (let i = 0; i < keys.length; i++) {
      if (this.originalFilterData[keys[i]] !== this.changedFilterData[keys[i]]) {
        changedvalus.push(keys[i]);
      }
    }
    this.filterApplied = false;
    if (changedvalus.length > 0) {
      this.filterApplied = true;
    }
    if (key === 'selectedDispatchAddress') {
      this.getPickupAddress();
    }
  }

  onClickBookNow() {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    const data = {
      eventId: this.eventIdParam,
      action: this.approve == 'true' ? "approve" : "reject",
      passengerRequestCount: this.passengerRequestCount,
      luggageRequestCount: this.luggageRequestCount
    }

    this.commonBindingDataService.specialRequestApproveOrReject(this.bookingDetails.id, data).subscribe((result: any) => {
      this.uiService.showMessage(result.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.onClickBack();
      this.reloadGrid();
      this.resetCounters();
      this.isSubmitting = false;
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
      this.isSubmitting = false;
    })
  }
  // aplly btn  change color end

  onMergeComplete(result: any) {
    this.refreshGrid();
    setTimeout(() => {
      this.gridRef2?.clearRowSelection();
    }, 100);
  }

  onMergePopupClose() {
    this.refreshGrid();
    setTimeout(() => {
      this.gridRef2?.clearRowSelection();
    }, 100);
  }

  ngOnDestroy() {
    if (this._broadSub) {
      this._broadSub.unsubscribe();
    }
  }

  openUnmergePopup(data) {
    this.confirmationService.confirm({
      message: 'This is a merge booking, confirming the unmerging you can now merge additional booking?',
      accept: () => {
        this.performUnmerge(data);
      }
    });
  }

  performUnmerge(data) {
    const unmergeData = {
      tourIdList: [data.id],
    };
    
    this.bookingService.unmergeBookings(this.eventIdParam, unmergeData).subscribe(
      (result) => {
        this.uiService.showMessage(result.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
        this.refreshGrid();
        this.commonBindingDataService.bookingTabCountChange.next(true);
      },
      (error) => {
        this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
        this.refreshGrid();
      }
    );
  }

  closeCancellationReasonPopup(): void {
    this.showCancellationReasonPopup = false;
    this.refreshGrid();
  }

  onCancellationConfirm(event: { passengerNote: string; bookingNote: string }): void {
    this.showCancellationReasonPopup = false;
    this.refreshGrid();
  }
}
